import { store } from '../redux/sagas'
import * as Actions from './constants'

export const setMagazineListAction = (data) => {
  store.dispatch({
    type: Actions.MAGAZINE_DATA_GET,
    payload: data,
  });
};

export const setMagazineFavListAction = (data) => {
  store.dispatch({
    type: Actions.MAGAZINE_FAV_DATA_GET,
    payload: data,
  });
};

export const setMagazineLikeListAction = (data) => {
  store.dispatch({
    type: Actions.MAGAZINE_LIKE_DATA_GET,
    payload: data,
  });
};

export const setYearsAction = (data) => {
  store.dispatch({
    type: Actions.YEAR_DATA_GET,
    payload: data,
  });
};

export const setBlogFeatureAction = (data) => {
  store.dispatch({
    type: Actions.BLOG_FEATURE_DATA_GET,
    payload: data,
  });
};

export const setPurchasedCourseListAction = (data) => {
  store.dispatch({
    type: Actions.PURCHASED_COURSE_DATA_GET,
    payload: data,
  });
};

export const setLikeCourseListAction = (data) => {
  store.dispatch({
    type: Actions.LIKE_COURSE_DATA_GET,
    payload: data,
  });
};

export const setEducationTechnicalCategoryAction = (data) => {
  store.dispatch({ type: Actions.EDUCATION_TECHNICAL_CATEGORY_GET, payload: data });
};

export const setEducationTechnicalsByCategoryAction = (data) => {
  store.dispatch({ type: Actions.EDUCATION_TECHNICALS_BY_CATEGORY_GET, payload: data });
};

export const setEducationCourseCategoryAction = (data) => {
  store.dispatch({ type: Actions.EDUCATION_COURSE_CATEGORY_GET, payload: data });
};

export const setEducationTeachersAction = (data) => {
  store.dispatch({ type: Actions.EDUCATION_TEACHERS_GET, payload: data });
};

export const setTechnicalDetailAction = (data) => {
  store.dispatch({ type: Actions.TECHNICAL_DETAIL_GET, payload: data });
};

export const setTechnologyDetailListAction = (data) => {
  store.dispatch({ type: Actions.TECHNOLOGY_DETAIL_LIST_GET, payload: data });
};

export const setOnlineClassDetailAction = (data) => {
  store.dispatch({ type: Actions.ONLINE_CLASS_DETAIL_GET, payload: data });
};

export const setOnlineClassRelatedAction = (data) => {
  store.dispatch({ type: Actions.ONLINE_CLASS_RELATED_GET, payload: data });
};

export const setProductListAction = (data) => {
  store.dispatch({ type: Actions.PRODUCT_DATA_GET, payload: data });
};

export const setProductCategoryAction = (data) => {
  store.dispatch({ type: Actions.PRODUCT_CATEGORY_GET, payload: data });
};

export const setProductFeaturedAction = (data) => {
  store.dispatch({ type: Actions.PRODUCT_FEATURED_GET, payload: data });
};

export const setProductDetailAction = (data) => {
  store.dispatch({ type: Actions.PRODUCT_DETAIL_GET, payload: data });
};

export const setProductBannersAction = (data) => {
  store.dispatch({ type: Actions.PRODUCT_BANNERS_GET, payload: data });
};

export const setEducationBannersAction = (data) => {
  store.dispatch({ type: Actions.EDUCATION_BANNERS_GET, payload: data });
};

export const setAdsAction = (data) => {
  store.dispatch({ type: Actions.ADS_DATA_GET, payload: data });
};